/* eslint-disable import/no-anonymous-default-export */
import { Button, Collapse, Form, Input, Modal, notification, Select, Image, Alert } from "antd";
import { useForm } from "antd/es/form/Form";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import useTitularesVehiculoAPI, { TitularVehiculo } from "../../titulares-vehiculo/useTitularesVehiculoAPI";
import useInfraccionesRadarAPI, { Infraccion } from "../../infracciones/hooks/useInfraccionesAPI";
import { InfraccionesBrowserContext } from "../../infracciones/components/InfraccionesBrowser";
import RenombradoViewer from "../../lotes-renombrado/components/RenombradoViewer";
import InputUbicacion from "../../titulares-vehiculo/components/InputUbicacion";
import useLotesRenombradoAPI, { DatosRenombrado } from "../../lotes-renombrado/hooks/useLotesRenombradoAPI";
import { PartialDeep } from "type-fest";
import useCodigosInfraccionAPI from "../../codigos-infraccion/hooks/useCodigosInfraccionAPI";
import _ from "lodash";
import Magnifier from "react-magnifier";
import InfoAtajosVerify from "./InfoAtajosVerify";
import { InfoCircleOutlined } from "@ant-design/icons";
import useUtils from "../../common/hooks/useUtils";

const Container = styled.div`
display: grid;
grid-template-columns: 1fr;
`;

const ImgPatente = styled(Image)``;

const StyledForm = styled(Form)`
padding: 1rem;
display: grid;
grid-gap: 0.5rem;
`;

const DatosGrid = styled.div`
display:grid;
grid-template-columns:repeat(auto-fit,minmax(100px,1fr));
grid-gap:0.5rem;
`;
const DatosVehiculo = styled(DatosGrid)``;
const DatosNombre = styled(DatosGrid)``;
const DatosLocalidad = styled(DatosGrid)``;
const DatosDireccion = styled(DatosGrid)``;

const ContainerImagenes = styled.div`
display: grid;
grid-template-columns: 1fr 200px;
min-height: 550px;
box-shadow: rgb(0 0 0 / 12%) 0px 1px 3px, rgb(0 0 0 / 24%) 0px 1px 2px;
.magnifier-image
{
    height:100%;
}
.contenedor-imagen
{
    width:100%;
    height:100%;
    max-height:60vh;
}
& > :first-child
{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px,1fr));
    figure
    {    
        background: black;
        display: flex;
        align-items: center;
        position:relative;
        span
        {
            position:absolute;
            background: white;
            color: black;
            padding: 0.5rem;
            bottom: 0.5rem;
            right: 0.5rem;
        }
        &:hover > svg
        {
            display:none;
        }
        svg 
        {
            position:absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            z-index:1;
        }
    }
}
`;

const ContainerCanvas = styled.div`
background: #e0e0e0;
padding: 0.5rem;
display: flex;
flex-direction: column;
justify-content: space-between;
`;

const ButtonContainer = styled.div<{ disabled?: boolean }>`
display: grid;
grid-gap: 0.25rem;
& button
{
    opacity:${(props) => props.disabled ? 0.5 : 1}!important;
    pointer-events:${(props) => props.disabled ? 'none' : 'inherit'}!important;
}
`;

const Patente = styled.span`
font-weight:600;
text-align:center;
display: block;
margin-top: 0.4rem;
font-size:0.9rem;
`;

const Status = styled(Patente)`
color:#0277bd;
&.status-VERIFICADA
{
    color:#43a047;
}
&.status-DESCARTADA
{
    color:#e53935;
}

`;

const ExtraData = styled.div`
text-align: center;
border-top: 1px solid #bdbdbd;
padding-top: 0.75rem;
margin-top:0.75rem;
display:grid;
gap:0.5rem;
font-size:0.9rem;
line-height:1.2;
.empty
{
    font-weight:600;
    color:#e53935;
}
span:not(:last-child)
{    
    border-bottom: 1px solid white;
    padding-bottom: 0.5rem;
}


`;

export default (props: {}) => {
    const browserContext = useContext(InfraccionesBrowserContext);
    const { getKeywordsOrganismos } = useUtils();
    //const {crop, changeZoom} = useCropPlate();
    const [form] = useForm<Partial<TitularVehiculo>>();
    const [modalVisible, setModalVisible] = useState(false);
    const [infraccion, setInfraccion] = useState<Infraccion>(browserContext.infraccion);
    const api = useInfraccionesRadarAPI();
    const lotesRenombradoApi = useLotesRenombradoAPI();
    const titularesVehiculoApi = useTitularesVehiculoAPI();
    const [titular, setTitular] = useState<TitularVehiculo>();
    const [loadingDiscard, setLoadingDiscard] = useState(false);
    const [loadingVerify, setLoadingVerify] = useState(false);
    const [loadingSendToQuery, setLoadingSendToQuery] = useState(false);
    const [loadingLocalQuery, setLoadingLocalQuery] = useState(false);
    const [isModalAtajosVisible, setIsModalAtajosVisible] = useState<boolean>(false)
    const codigosInfraccionApi = useCodigosInfraccionAPI();
    const [diasAntiguedadTitular, setDiasAntiguedadTitular] = useState(60);

    const onBeforeSaveRenombrado = (data: PartialDeep<DatosRenombrado>) => {
        if (data.Patente !== infraccion?.Patente) {
            //Si cambia la patente, reseteo el campo con los datos del titular, ya que los mismos deberan volverse a consultar
            form.resetFields();
            setTitular(undefined);
            //setInfraccion({...{...infraccion, ...data},...{Estado:'CONSULTADA'}});
        }
        setModalVisible(false);
        //browserContext.loadInfracciones();
    };

    useEffect(() => {
        setInfraccion(browserContext.infraccion);
    }, [browserContext.infraccion]);

    const checkInfraccionDuplicada = async (infraccion: Infraccion) => {

        const response = await api.checkDuplicada(infraccion.Id);
        return response;
    }

    const checkDatosTituarIncompletos = (titular: Partial<TitularVehiculo>) => {
        console.log(titular);
        if ((titular.Nombre?.length ?? 0) < 3) return { esValido: false, mensaje: 'Nombre incompleto' };
        if (titular.TipoTitular != "EMPRESA" && (titular.Apellido?.length ?? 0) < 3) return { esValido: false, mensaje: 'Apellido incompleto' };
        if ((titular.CalleTitular?.length ?? 0) < 5) return { esValido: false, mensaje: 'Calle incompleta' };
        if ((titular.LocalidadTitular?.length ?? 0) < 3) return { esValido: false, mensaje: 'Localidad incompleta' };
        if ((titular.ProvinciaTitular?.length ?? 0) < 3) return { esValido: false, mensaje: 'Provincia incompleta' };
        return { esValido: true, mensaje: '' };
    }

    const verifyInfraccion = async () => {
        const titular = { ...form.getFieldsValue() };
        const titularChanged = hasTitularChanged()
        const currentInfraccion = infraccion;
        var datosDuplicadaAceptado = true;
        var datosTitularAceptados = true;
        setLoadingVerify(true);

        let datosTitular = checkDatosTituarIncompletos(titular);

        if (!datosTitular.esValido) {
            datosTitularAceptados = await new Promise<boolean>((resolve) => {
                Modal.confirm({
                    title: 'Posible falta de datos del titular',
                    content: [
                        //dataDuplicada.msg,
                        <div key="msg" style={{ whiteSpace: 'pre-line', marginBottom: 10 }}>
                            {'Por favor revise:' + datosTitular.mensaje}
                        </div>,
                        <Alert message={'Click en CONTINUAR para verificar la infracción... CANCELAR para volver a revisar.'} type="warning" showIcon style={{ marginTop: 10 }} />
                    ],
                    okText: 'Continuar',
                    cancelText: 'Cancelar',
                    width: 1000,
                    onOk: () => resolve(true),
                    onCancel: () => {
                        notification.info({
                            message: 'Revisar la infracción',
                            placement: 'bottomRight'
                        });
                        resolve(false);
                    }
                });
            });
        }

        browserContext.goForward();
        browserContext.queue.push(async () => {
            const dataDuplicada = await checkInfraccionDuplicada(currentInfraccion)
            let hayInfraccionDia = false;

            if (dataDuplicada && dataDuplicada.duplicada && datosTitularAceptados) {
                datosDuplicadaAceptado = await new Promise<boolean>((resolve) => {
                    Modal.confirm({
                        title: 'Posible infracción DUPLICADA - rango de 10 minutos',
                        content: [
                            //dataDuplicada.msg,
                            <div key="msg" style={{ whiteSpace: 'pre-line', marginBottom: 10 }}>
                                {dataDuplicada.msg}
                            </div>,
                            <Alert message={'Sugerencia: ' + dataDuplicada.sugerencia} type="info" showIcon style={{ marginTop: 10 }} />,
                            <Alert message={'Click en CONTINUAR para verificar la infracción... CANCELAR para volver a revisar.'} type="warning" showIcon style={{ marginTop: 10 }} />
                        ],
                        okText: 'Continuar',
                        cancelText: 'Cancelar',
                        width: 1000,
                        onOk: () => resolve(true),
                        onCancel: () => {
                            notification.info({
                                message: 'Revisar la infracción',
                                placement: 'bottomRight'
                            });
                            resolve(false);
                        }
                    });
                });
            }

            if (datosDuplicadaAceptado && datosTitularAceptados) {
                if (titularChanged) {
                    //Actualizo los datos del titular
                    titular.DireccionCompletaTitular = [
                        titular.CalleTitular,
                        titular.NroTitular,
                        titular.PisoTitular,
                        titular.DeptoTitular
                    ]
                        .filter(valor => valor !== null && valor !== undefined && valor !== '')
                        .join(' ')
                        .trim();
                    titular.ProvinciaTitularOriginal = titular.ProvinciaTitular;
                    titular.LocalidadTitularOriginal = titular.LocalidadTitular;
                    const responseTitular = await titularesVehiculoApi.save(titular);
                    
                    if (responseTitular.error) {
                        notification.error({ message: "Error al actualizar el titular" });
                        setLoadingVerify(false);
                        return;
                    }
                }
                //Marco la infracción como verificada
                const responseVerify = await api.verify(currentInfraccion.Id, titular.Id!);
                if (responseVerify.error) {
                    notification.error({ message: "Error al verificar" });
                }
                setLoadingVerify(false);
                await browserContext.refreshInfraccion();
            }
        });

    }

    const hasTitularChanged = () => {
        return JSON.stringify({ ...infraccion.Titular, ...form.getFieldsValue() }) != JSON.stringify(infraccion.Titular)
    }

    const verifyTitularOrganismo = async () => {
        // Esta funcion verifica si los datos del titular estan relacionados a entidades u organismos, para avisar al verificador.
        const titular = { ...form.getFieldsValue() };
        const keywords: string[] = getKeywordsOrganismos();
        const hasKeyword: boolean = keywords.some((keyword) =>
            [titular.Nombre, titular.Apellido, titular.NombreCompletoTitular].some(
                (field) => field?.toLowerCase().includes(keyword.toLowerCase())
            )
        );
        if (hasKeyword) {
            Modal.confirm({
                title: "Atencion",
                content:
                    "Se detecto que los datos de titularidad estan relacionados con entidades gubernamentales, organismos o servicios de emergencia, ¿Desea continuar?",
                maskClosable: false,
                okText: "Verificar",
                cancelText: "Volver",
                onOk: () => verifyInfraccion(), //verifyDuplicate(),
                onCancel: () => {
                    return;
                },
            });
        } else {
            verifyInfraccion() //verifyDuplicate();
        }
    };

    const verifyVelocidadAlta = async () => {
        // Esta funcion verifica si la infraccion supera cierto limite de velocidad, por ej 150kmh. ya que hay casos de mediciones con error, esto servira para advertir al verificador  que chequee la infraccion, si es valida la velocidad o se trata de un error.
        let infraccionVelocidad = browserContext.infraccion.ValorMedido;
        if (infraccionVelocidad !== 0 && infraccionVelocidad >= 150) {
            Modal.confirm({
                title: "Atencion: Se registro una velocidad alta",
                content:
                    "La actual infracción registra una velocidad que supera los 150 km/h. ¿Que desea hacer?",
                maskClosable: false,
                okText: "Verificar",
                cancelText: "Volver y revisar",
                closable: true,
                onOk: () => verifyTitularOrganismo(),
                onCancel: () => {
                    return;
                },
            });
        } else {
            verifyTitularOrganismo();
        }
    }

    const discardInfraccion = async () => {
        setLoadingDiscard(true);
        browserContext.goForward();
        browserContext.queue.push(async () => {
            const response = await api.discard(infraccion.Id);
            if (response.error) {
                notification.error({ message: "Error al descartar la infracción" })
            }
            setLoadingDiscard(false);
            await browserContext.refreshInfraccion();
        });
    };

    const sendToQuery = () => {

        Modal.confirm({
            title: "¿Marcar como no consultada?",
            content: "Podrá consultarla en un lote más adelante",
            okText: "Aceptar",
            cancelText: "Cancelar",
            onOk: async () => {
                setLoadingSendToQuery(true);
                await api.sendToQuery(infraccion.Id);
                setLoadingSendToQuery(false);
                await browserContext.loadInfracciones();
            }

        });
    };

    const localQuery = async () => {
        setLoadingLocalQuery(true);
        const response = await titularesVehiculoApi.queryTitular(infraccion.Patente, moment(infraccion.FechaHora).toISOString(), diasAntiguedadTitular);
        setLoadingLocalQuery(false);
        if (!response.data?.value.length) {
            notification.error({ message: "Patente no encontrada en la base de datos local" });
            return;
        }
        else {
            notification.success({ message: "Titular encontrado" })
        }
        form.setFieldsValue(response.data.value[0]);
        setTitular(response.data.value[0]);
    };

    const getStatus = (status: string) => {
        return { 'CONSULTADA': 'Pendiente', 'VERIFICADA': 'Verificada', 'DESCARTADA': 'Descartada' }[status];
    };

    const loading = () => loadingVerify || loadingDiscard || loadingSendToQuery || loadingLocalQuery;
    useEffect(() => {
        form.setFieldsValue(infraccion.Titular);
        setTitular(infraccion.Titular);

    }, [])

    window.onkeydown = (e) => {
        if (e.key === "F8") {
            e.preventDefault();
            const button = document.getElementById("localQuery-btn");
            button?.click();
        } else if (e.key === "F11") {
            e.preventDefault();
            const button = document.getElementById("verify-btn");
            button?.click();
        } else if (e.key === "F12") {
            e.preventDefault();
            const button = document.getElementById("descartar-btn");
            button?.click();
        } else if (e.key === "ArrowLeft") {
            e.preventDefault();
            browserContext.goBackward();
        } else if (e.key === "ArrowRight") {
            e.preventDefault();
            browserContext.goForward();
        }
    }

    return (
        <Container>

            <Modal width={1300} footer={null} visible={modalVisible} onCancel={() => setModalVisible(false)}>
                {/*<RenombradoViewer
                    renombrar={api.editRenombrado}
                    onSave={onRenombrado}
                    infraccion={infraccion!}
                />*/}
                <RenombradoViewer
                    listCodigosInfraccion={async (etiqueta: string) => {
                        return codigosInfraccionApi
                            .list({ $filter: [`Etiqueta eq '${etiqueta}'`], $expand: ['EtiquetasImagenes'] });
                    }}
                    renombrar={lotesRenombradoApi.editRenombrado}
                    onBeforeSave={onBeforeSaveRenombrado}
                />
            </Modal>

            <Modal
                onOk={() => {
                    setIsModalAtajosVisible(false)
                }}
                okText={"Aceptar"}
                cancelButtonProps={{ style: { display: 'none' } }}
                width={"90%"}
                style={{ maxWidth: "768px" }}
                visible={isModalAtajosVisible}
                onCancel={() => {
                    setIsModalAtajosVisible(false)
                }}
            >
                <InfoAtajosVerify />
            </Modal>
            <ContainerImagenes>
                <div>
                    {infraccion.Imagenes!
                        .map((image, index) => (
                            (index == infraccion.ImagenDestacadaIndice || (infraccion.EtiquetasImagenes?.filter(e => e.EtiquetaIndex == index.toString()).length ?? 0) > 0)) &&
                            <figure key={index}>
                                {(infraccion.OverlaysImagenes?.filter(o => o.ImagenId == image.Id)?.length ?? 0) > 0 &&
                                    <svg dangerouslySetInnerHTML={{ __html: infraccion.OverlaysImagenes!.filter(o => o.ImagenId == image.Id).at(0)!.Svg }}>
                                    </svg>
                                }
                                {/*<ImagenInfraccion rootClassName="contenedor-imagen" src={image.FullUrl} />*/}
                                <Magnifier height={"100%"} mgHeight={150} mgWidth={200} mgShape="square" src={image.FullUrl} />
                                <span>{infraccion.EtiquetasImagenes?.filter(e => e.EtiquetaIndex == index.toString()).at(0)?.Etiqueta.Nombre ?? "Imagen destacada"}</span>
                            </figure>
                        )
                        .reverse()
                    }
                </div>
                <ContainerCanvas>
                    <div>
                        <strong>{infraccion.Id}</strong>
                        {/*<CanvasPatente ref={canvasRef} />*/}
                        <ImgPatente src={infraccion.ImagenPatente?.FullUrl} />
                        <Patente>{infraccion.Patente}</Patente>
                        <Status className={`status-${infraccion.Estado}`}>{getStatus(infraccion.Estado)}</Status>
                        <ExtraData>
                            <span>{moment(infraccion.FechaHora).format("DD/MM/YYYY HH:mm:s")}</span>
                            {/*infraccion.Lugar && <span>{infraccion.Lugar}</span>}
                            {!infraccion.Lugar && <span className="empty">Sin lugar</span>*/}
                            {infraccion.Extranjero && <span>Extranjero</span>}


                            {(!_.isEmpty(titular?.MarcaVehiculo) || !_.isEmpty(titular?.ModeloVehiculo)) &&
                                <span><a href={`https://www.google.com/search?q=${titular?.MarcaVehiculo} ${titular?.ModeloVehiculo}&tbm=isch`} target={"_blank"}>{titular?.MarcaVehiculo} {titular?.ModeloVehiculo}</a></span>}
                            {titular && (_.isEmpty(titular?.MarcaVehiculo) && _.isEmpty(titular?.ModeloVehiculo)) &&
                                <span className="empty">Sin marca y modelo</span>}
                            {!titular &&
                                <span className="empty">Sin titular</span>}
                            <span>{_.isEmpty(infraccion.CodigoInfraccion?.Abreviatura) ?
                                infraccion.CodigoInfraccion?.Descripcion : infraccion.CodigoInfraccion?.Abreviatura}</span>
                            {_.isEmpty(infraccion.Patente) && <span className="empty">Ilegible</span>}


                        </ExtraData>
                    </div>
                    <ButtonContainer  >
                        <Button id="verify-btn" style={{ background: "#43a047", color: "white" }} loading={loadingVerify} disabled={loading() || !titular} onClick={verifyVelocidadAlta}>Verificar</Button>
                        <Button id="descartar-btn" style={{ background: "#e53935", color: "white" }} loading={loadingDiscard} disabled={loading()} onClick={discardInfraccion}>Descartar</Button>
                        <Button style={{ background: "#0288d1", color: "white" }} loading={loadingSendToQuery} disabled={loading()} onClick={sendToQuery}>No consultada</Button>
                        <Button id="localQuery-btn" style={{ background: "#0288d1", color: "white" }} loading={loadingLocalQuery} disabled={loading()} onClick={localQuery}>Consulta local</Button>
                        <Input min={0} max={365} defaultValue={60} onChange={(e) => setDiasAntiguedadTitular(parseInt(e.target.value) ?? 0)} suffix="días antigüedad" />
                        <Button onClick={() => setModalVisible(true)} type="link" disabled={loading()} >Renombrar</Button>
                        <Button onClick={() => setIsModalAtajosVisible(true)} type="default" icon={<InfoCircleOutlined />} size="small" style={{ marginTop: "0.5rem", color: "var(--primary-color)" }}>
                            Ver atajos de teclado
                        </Button>
                    </ButtonContainer>
                </ContainerCanvas>

            </ContainerImagenes>
            <Collapse>
                <Collapse.Panel forceRender header="Modificar datos del titular" key="1">
                    <StyledForm
                        layout="vertical"
                        form={form}
                    >
                        <DatosVehiculo>
                            {/*
                    <Form.Item style={{ margin: 0 }} name={"PatenteVehiculo"} label="Patente">
                        <Input />
                    </Form.Item>*/}

                            <Form.Item style={{ margin: 0 }} name={"MarcaVehiculo"} label="Marca">
                                <Input />
                            </Form.Item>

                            <Form.Item style={{ margin: 0 }} name={"ModeloVehiculo"} label="Modelo">
                                <Input />
                            </Form.Item>
                        </DatosVehiculo>

                        <DatosNombre>
                            <Form.Item
                                rules={[{ required: true, message: 'Campo requerido' }]}
                                style={{ margin: 0 }} name={"Nombre"} label="Nombre">
                                <Input />
                            </Form.Item>

                            <Form.Item style={{ margin: 0 }} name={"Apellido"} label="Apellido">
                                <Input />
                            </Form.Item>

                            <Form.Item
                                normalize={(value, prevValue, allValues) => value.toUpperCase()}
                                style={{ margin: 0 }}
                                name={"CuilTitular"}
                                label="Cuil-Cuit">
                                <Input />
                            </Form.Item>

                            <Form.Item style={{ margin: 0 }} name={"TipoTitular"} label="Tipo">
                                <Select>
                                    <Select.Option key={"MASCULINO"}>
                                        MASCULINO
                                    </Select.Option>
                                    <Select.Option key={"FEMENINO"}>
                                        FEMENINO
                                    </Select.Option>
                                    <Select.Option key={"EMPRESA"}>
                                        EMPRESA
                                    </Select.Option>
                                    <Select.Option key={"OTRO"}>
                                        OTRO
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                        </DatosNombre>

                        <DatosLocalidad>
                            <Form.Item
                                normalize={(value, prevValue, allValues) => value.toUpperCase()}
                                style={{ margin: 0 }}
                                name={"ProvinciaTitular"}
                                label="Provincia">
                                <InputUbicacion type="PROVINCIA" />
                            </Form.Item>

                            <Form.Item
                                normalize={(value, prevValue, allValues) => value.toUpperCase()}
                                style={{ margin: 0 }}
                                name={"DepartamentoTitular"}
                                label="Departamento/Partido">
                                <InputUbicacion type="DEPARTAMENTO" provinciaField="ProvinciaTitular" />
                            </Form.Item>

                            <Form.Item
                                normalize={(value, prevValue, allValues) => value.toUpperCase()}
                                style={{ margin: 0 }}
                                name={"LocalidadTitular"}
                                label="Localidad">
                                <InputUbicacion type="LOCALIDAD" provinciaField="ProvinciaTitular" departamentoField="DepartamentoTitular" />
                            </Form.Item>

                            <Form.Item style={{ margin: 0 }} name={"CodigoPostalTitular"} label="Código postal">
                                <Input />
                            </Form.Item>
                        </DatosLocalidad>

                        <DatosDireccion>
                            <Form.Item style={{ margin: 0 }} name={"CalleTitular"} label="Calle">
                                <Input />
                            </Form.Item>

                            <Form.Item style={{ margin: 0 }} name={"NroTitular"} label="Número">
                                <Input />
                            </Form.Item>

                            <Form.Item style={{ margin: 0 }} name={"PisoTitular"} label="Piso">
                                <Input />
                            </Form.Item>

                            <Form.Item style={{ margin: 0 }} name={"DeptoTitular"} label="Depto.">
                                <Input />
                            </Form.Item>
                        </DatosDireccion>
                        <Form.Item style={{ margin: 0 }} name={"Id"} hidden>
                            <Input readOnly />
                        </Form.Item>
                    </StyledForm>

                </Collapse.Panel>
            </Collapse>
        </Container>
    );
};